/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////

export const FONT_FAMILY = {
  heading: `'BodegaScript', serif;`,
  subHeading: `'Cinzel Decorative', serif;`,
  body: `'Gelasio', serif;`,
  button: `'Cormorant Infant', serif`,
  // arabicText: `"Amiri Quran", serif`,
  arabicText: `'TraditionalArabic', serif`,
};

export const TEXT_PROPS = {
  heading: {
    fontFamily: 'heading',
    fontSize: 'heading',
    fontWeight: 'heading',
    fontStyle: 'var(--fontItalic-heading)',
    lineHeight: '1.6em',
    textAlign: 'center',
    color: 'mainColorText',
    textTransform: 'lowercase',
  },
  subHeading: {
    fontFamily: 'subHeading',
    fontSize: 'subHeading',
    fontWeight: 'subHeading',
    fontStyle: 'var(--fontItalic-subHeading)',
    lineHeight: '1.2',
    color: 'secondaryColorText',
    textAlign: 'center',
    textTransform: 'capitalize',
  },
  body: {
    fontFamily: 'body',
    fontSize: 'body',
    fontWeight: 'body',
    fontStyle: 'var(--fontItalic-body)',
    color: 'secondaryColorText',
    textAlign: 'center',
  },
  button: {
    fontFamily: 'button',
    fontSize: 'button',
    fontWeight: 'button',
    fontStyle: 'var(--fontItalic-button)',
    color: 'mainColorText',
    textAlign: 'center',
  },
};

export const BUTTON_PADDING_PROPS = {
  ...TEXT_PROPS.button,
  variant: 'solid',
  padding: '16px 18px',
  borderRadius: 'md',
  background: 'bgPrimary',
  color: 'white',
  size: 'sm',
  boxShadow: 'sm',
  _active: { opacity: '.8' },
  _hover: { opacity: '.8' },
  _focus: { opacity: '.8' },
};
